import script from "./TeamMembers.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamMembers.vue?vue&type=script&setup=true&lang=js"

import "./TeamMembers.vue?vue&type=style&index=0&id=7e22cf8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e22cf8c"]])

export default __exports__